<template>
  <div class="table-page">
    <top-bar :topbarList="tableTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { tableIndexMixins } from "@/mixins/tableIndexMixins";

export default {
  mixins: [tableIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.table-page {
  height: 100%;
}
</style>
